import * as paymentStatuses from 'app/common/actions/shop/order/paymentStatuses';

const getNames = () => ({ // это для будущей локализации
  [paymentStatuses.PAYMENT_STATUS_PAID]: {
    id: paymentStatuses.PAYMENT_STATUS_PAID,
    title: 'Оплачено',
  },
  [paymentStatuses.PAYMENT_STATUS_UNPAID]: {
    id: paymentStatuses.PAYMENT_STATUS_UNPAID,
    title: 'Не оплачено',
  },
  // deprecated
  [paymentStatuses.PAYMENT_STATUS_CANCELED]: {
    id: paymentStatuses.PAYMENT_STATUS_CANCELED,
    title: 'Отменено',
  },
  // end - deprecated
  [paymentStatuses.PAYMENT_STATUS_REFUNDED]: {
    id: paymentStatuses.PAYMENT_STATUS_REFUNDED,
    title: 'Возвращено',
  },
});

export default getNames;
